var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-menu"},[(_vm.menuData && (!_vm.sectionName || _vm.sectionData))?_c('SPMenu',{attrs:{"menu":_vm.menuData,"section":_vm.sectionData,"showFootnotes":_vm.showFootnotes}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }